import React, {Component} from 'react';
import {Route, Switch, Link} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Breadcrumb, Menu} from 'semantic-ui-react';


import CustomDivider from '../../components/extras/CustomDivider';
import OurForm from '../../components/settings/OurForm';
import SocialForm from '../../components/settings/SocialForm';
import Logo from '../../components/settings/Logo';
import CheckPermission from "../../components/extras/CheckPermission";
import BusinessHoursForm from "../../components/settings/BusinessHoursForm";

class MyBussiness extends Component {

    state = {activeItem: 'information'};

    handleItemClick = (e, {name}) => this.setState({activeItem: name});

    render() {
        const {activeItem} = this.state
        return (
            <div>
                <Helmet>
                    <title>Mi Negocio | Configuraciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Mi Negocio</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Menu>
                    <Menu.Item
                        name='information'
                        active={activeItem === 'information'}
                        onClick={this.handleItemClick}
                        as={Link} to='/settings/my-bussiness'
                    >
                        Información
                    </Menu.Item>

                    <Menu.Item
                        name='logo'
                        active={activeItem === 'logo'}
                        onClick={this.handleItemClick}
                        as={Link} to='/settings/my-bussiness/logo'
                    >
                        Logo
                    </Menu.Item>

                    <Menu.Item
                        name='social'
                        active={activeItem === 'social'}
                        onClick={this.handleItemClick}
                        as={Link} to='/settings/my-bussiness/social'
                    >
                        Redes Sociales
                    </Menu.Item>

                    <Menu.Item
                        name='business_hours'
                        active={activeItem === 'business_hours'}
                        onClick={this.handleItemClick}
                        as={Link} to='/settings/my-bussiness/bussiness-hours'
                    >
                        Horario de Atención
                    </Menu.Item>
                </Menu>
                {this.props.children}
                <Switch>
                    <Route exact path={this.props.match.path} component={OurForm}/>
                    <Route exact path={`${this.props.match.path}/social`} component={SocialForm}/>
                    <Route exact path={`${this.props.match.path}/logo`} component={Logo}/>
                    <Route exact path={`${this.props.match.path}/bussiness-hours`} component={BusinessHoursForm}/>
                </Switch>
                <CheckPermission access='settings__my_bussiness'/>
            </div>
        );
    }
}

export default MyBussiness;



// WEBPACK FOOTER //
// ./src/containers/settings/MyBussiness.js